export const getEncryptedSsoToken = () => {
    return "";
};
export const setEncryptedSsoToken = () => {
    return "";
};
export { getApiKey, setApiKey, getApiSecret, setApiSecret } from "./common";
